var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneFillIcon = function SvgPhoneFillIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2038",
    transform: "translate(-334 -115.959)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "rgba(34,203,91,0.1)",
    "data-name": "Rectangle 1884",
    rx: 8,
    transform: "translate(334 115.959)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M353.516 136.446c4.029 4.028 4.943-.631 7.508 1.932 2.472 2.472 3.894 2.967.76 6.1-.392.315-2.886 4.11-11.649-4.651s-4.972-11.259-4.657-11.651c3.141-3.141 3.628-1.712 6.1.761 2.566 2.565-2.091 3.482 1.938 7.509",
    "data-name": "Path 18429"
  }))));
};
export default SvgPhoneFillIcon;